<script lang="ts">
  export let align: 'left' | 'center' | 'right' = 'center';
  export let size: 'sm' | 'md' | 'lg' = 'md';
  export let animate = false;
  export let inline = false;
</script>

<div class="text-container" class:inline>
  <p
    class="text delay-entry"
    class:sm={size === 'sm'}
    class:md={size === 'md'}
    class:lg={size === 'lg'}
    class:animate
    style="
      text-align: {align};
      color: var(--text-color, inherit);
    "
  >
    <slot />
  </p>
</div>

<style lang="postcss">
  .text-container {
    container-type: inline-size;
    container-name: text;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .text-container.inline {
    container-type: normal; /* Disable container queries for inline text */
  }

  .text {
    margin: 0;
    line-height: 1.2;
    max-width: 600px;
  }

  /* Style for data-color attribute */
  :global([data-color]) .text {
    color: var(--text-color, attr(data-color));
  }

  .sm {
    font-size: 0.875rem;
  }
  .md {
    font-size: 1.1rem;
  }
  .lg {
    font-size: 1.225rem;
  }

  @container text (max-width: 280px) {
    .sm {
      font-size: 0.75rem;
    }
    .md {
      font-size: 0.875rem;
    }
    .lg {
      font-size: 1rem;
    }
  }

  p {
    margin: 0;
    line-height: 1.2;
    font-size: 1rem;
    width: 100%;
  }

  @container (max-width: 280px) {
    p {
      font-size: 0.75rem;
      line-height: 1.3;
    }
  }
</style>
